import { useContext } from 'react';
import { DialogContext } from '../context/DialogProvider';

const useDialog = () => {
  const { setMessage, setTitle, setStatus } = useContext(DialogContext);
  return { setMessage, setTitle, setStatus };
};

export default useDialog;
